import cx from "@hsl/core/utils/cx";

interface Props {
    className?: string;
    children?: React.ReactNode;
}

export const Card = ({ children, className }: Props) => {
    return (
        <section
            className={cx(
                "relative z-[55] mt-4 min-h-[330px] w-screen -translate-x-4 bg-white px-4 pb-9 pt-6 shadow sm:w-full sm:translate-x-0 sm:px-6 md:px-8",
                className,
            )}
        >
            {children}
        </section>
    );
};
